var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.treatments.length)?_c('div',{staticClass:"group"},[_c('com-input',{attrs:{"input":_vm.input}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }